// extracted by mini-css-extract-plugin
export default {"Checkbox":"checkbox_Checkbox__NqAOy","CheckboxInput":"checkbox_CheckboxInput__LNW6r","Checkmark":"checkbox_Checkmark__TJiXi","Required":"checkbox_Required__M2jl0"};